import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'Tarjetas Silábicas Imprimibles',
  desc: 'Más de 100 sílabas listas para recortar y jugar.'
}, {
  title: 'Carteles de Lectura para el Hogar',
  desc: 'Convertí tu casa en un entorno lector.'
}, {
  title: 'Calendario de Progreso + Diploma Final',
  desc: 'Celebrá cada avance.'
}];
export function BonusesSection() {
  return <section className="py-12 md:py-16 bg-slate-50" data-id="element-29">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-30">
        <div className="text-center mb-8" data-id="element-31">
          <h2 className="text-2xl font-bold text-navy mb-2" data-id="element-32">
            🎁 LOS 3 BONOS EXCLUSIVOS
          </h2>
          <p className="text-slate-600" data-id="element-33">
            Siempre incluidos. Tres herramientas prácticas, listas para usar.
            Sin relleno.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-34">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm relative" data-id="element-35">
              <div className="text-xs font-bold text-slate-400 mb-1" data-id="element-36">
                Bono {i + 1}
              </div>
              <div className="flex items-center gap-2 mb-3" data-id="element-37">
                <span className="text-sm text-slate-400 line-through" data-id="element-38">
                  $4.990
                </span>
                <span className="bg-emerald-100 text-emerald-700 text-xs font-bold px-2 py-0.5 rounded" data-id="element-39">
                  GRATIS
                </span>
              </div>
              <h3 className="font-bold text-navy mb-2 leading-tight" data-id="element-40">
                {b.title}
              </h3>
              <p className="text-sm text-slate-600" data-id="element-41">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="text-center text-sm font-medium text-slate-600" data-id="element-42">
          Valor total de los 3 Bonos:{' '}
          <span className="line-through" data-id="element-43">$14.970</span> →{' '}
          <span className="text-emerald-600 font-bold" data-id="element-44">
            GRATIS en las dos opciones
          </span>
        </div>
      </div>
    </section>;
}